// Firebase
import { collection, DocumentData, serverTimestamp, doc, setDoc } from "firebase/firestore";
import { firestore } from "../firebase/firebase";

// Interfaces
import { Base } from "../interfaces/Base";

// this function is curried in order to pass a type, i.e. T, as a parameter.
// it is used to format the data receive from firestore into whatever we need.
//
// For exemple, firestore sends dates as { seconds, nanoseconds }. We can
// format them to an actual date.

// eslint-disable-next-line
export const genDoc: <T extends Base>() => (doc: DocumentData) => T =
    <T>() =>
    (doc: DocumentData) => {
        if (doc) {
            const data = doc.data();

            if (data) {
                if (data.dob) data.dob = new Date(data.dob.seconds * 1000);
                data.createdAt = new Date(data.createdAt.seconds * 1000);
                data.updatedAt = new Date(data.updatedAt.seconds * 1000);
                if (data.start) data.start = new Date(data.start.seconds * 1000);
                if (data.end) data.end = new Date(data.end.seconds * 1000);
                if (data.resetDate) data.resetDate = new Date(data.resetDate.seconds * 1000);
            }

            return data as T;
        }
        return {} as T;
    };

export const addParticipantLog = async (participantId: string, action: string) => {
    try {
        const newRef = doc(collection(firestore, "ParticipantLogs"));
        await setDoc(newRef, {
            id: newRef.id,
            participantId,
            action,
            createdAt: serverTimestamp(),
            isDeleted: false,
        });
    } catch (e) {
        console.error("Error adding participant log:", e);
    }
};
